import * as Three from 'three'
import vertexShader from './shaders/vertex.js'
import fragmentShader from './shaders/fragment.js'

export default class Plane{
    constructor(distortion,distortionStrength,frequency,strength,red,green,blue,speed,wSegments,hSegments,gen){
        this.distortion = distortion
        this.distortionStrength = distortionStrength
        this.frequency = frequency
        this.strength = strength
        this.red = red
        this.green = green
        this.blue = blue
        this.speed = speed
        this.gen = gen

        this.setGeometry(wSegments,hSegments)
        this.setMaterial()
        this.setMesh()
    }
    setGeometry(wSegments,hSegments){
        this.geometry = new Three.PlaneBufferGeometry(3,3,wSegments,wSegments)//3,3,1500,1500
    }
    setMaterial(){
        this.material = new Three.ShaderMaterial({
            uniforms:{
                uTime:{value: 0}
            },
            vertexShader:vertexShader(this.distortion,this.distortionStrength,this.frequency,this.strength),
            fragmentShader:fragmentShader(this.red,this.green,this.blue,this.gen),
            side:Three.DoubleSide
        })
    }
    setMesh(){
        this.mesh = new Three.Mesh(this.geometry, this.material)
        this.mesh.scale.set(3.3,3.3,3.3)
    }
    movePlane(x,y,z){
        this.mesh.position.set(x,y,z)
    }
    disable(){
        this.mesh.visible = false;
    }
    enable(){
        this.mesh.visible = true;
    }
    addPlane(scene){
        scene.add(this.mesh)
    }
    update(time){
        this.material.uniforms.uTime.value = time * (this.speed)
    }
    delete(scene){
        this.material.dispose()
        this.geometry.dispose()
        scene.remove(this.mesh)
    }

}